export default __webpack_public_path__ + "static/media/coffee.5d43d913.svg";